import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

interface DeleteRecipeDialogProps {
  open: boolean;
  recipeTitle?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteRecipeDialog: React.FC<DeleteRecipeDialogProps> = ({
  open,
  recipeTitle,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle sx={{ fontWeight: 'bold' }}>Delete Recipe</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete &quot;{recipeTitle}&quot;? This will also remove the link from any daily meal logs referencing it.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteRecipeDialog;
